<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <layout-header></layout-header>
          <breadcrumb63></breadcrumb63>
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar mt-3">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile">
                  <div class="card ml-md-3" id="shedule_container" style="border: none;">
                    <div class="row ml-md-1">
                      <div class="contents mt-2">
                        <div class="container">
                          <div class="row">

                            <div class="col-12 col-lg-4 mt-2">
                              <select id="joint" class="search-dropdown" 
                               @change="fetchVideos" v-model="selectedLanguage"
                              style="border: none; 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"
                              >
                                <option value="">Language</option>
                                <option value="Hindi">Hindi</option>
                                <option value="English">English</option>
                                <option value="Gujarati">Gujarati</option>
                                <option value="Marathi">Marathi</option>
                                <option value="Telugu">Telugu</option>
                                <option value="Kannada">Kannada</option>
                                <option value="Tamil">Tamil</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-4 mt-2">
                              <select id="joint" class="search-dropdown" 
                                @change="fetchVideos" v-model="selectedProcedure"
                              style="border: none; 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"
                              >
                                <option value="">Procedure</option>
                                <option value="SVF">SVF</option>
                                <option value="PRP">PRP</option>
                                <option value="Lipoaspiration">Lipoaspiration</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-4 mt-2">
                              <select id="exercise-type" class="search-dropdown"
                              @change="fetchVideos" v-model="selectedTestimonial"
                              style="border: none; 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"
                              >
                                <option value="0">Testimonial</option>
                                <option value="1">1</option>
                                <option value="0">0</option>
                              </select>
                            </div>

                            <div class="col-12 col-lg-4 mt-2">
                              <input type="text" 
                              placeholder="Search Library" 
                              class="search-input" 
                              style="border: 2px solid rgb(194,214,243,1); 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"/>
                            </div>
                            <div class="col-12 col-lg-4 mt-2">
                              <select id="joint" class="search-dropdown" 
                              @change="fetchVideos" v-model="selectedJoint"
                              style="border: none; 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"
                              >
                                <option value="">Select Joint</option>
                                <option value="knee">Knee</option>
                                <option value="hip">Hip</option>
                                <option value="shoulder">Shoulder</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-4 mt-2">
                              <select id="exercise-type" class="search-dropdown"
                              @change="fetchVideos" v-model="selectedExerciseType"
                              style="border: none; 
                              background-color: #f2f2f2; 
                              border-radius: 5px; 
                              padding: 5px;
                              width: 100%;"
                              >
                                <option value="">Type of exercise</option>
                                <option value="Strengthening">Strengthening</option>
                                <option value="Streching">Streching</option>
                              </select>
                            </div>
                          </div>

                          <!-- Video Library Grid -->
                          <div class="video-library mt-3">
                            <div class="video-card" v-for="video in videos" :key="video.id" @click="openModal(video.url)">
                              <div class="video-thumbnail">
                                <!-- Thumbnail Image instead of Video for Better Preview -->
                                <img :src="video.thumbnail" alt="Video Thumbnail" style="width: 100%; height: 150px; object-fit: cover;" />
                              </div>
                              <div class="video-info">
                                <h4>{{ video.title }}</h4>
                                <div class="share-icon">
                                  <a :href="`https://wa.me/?text=Check out this video: ${video.title} ${video.url}`" target="_blank">
                                    Share on WhatsApp <i class="fab fa-whatsapp" style="font-size: 15px; color: green"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>

    <!-- Video Modal -->
    <div v-if="modalVisible" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <!-- Displaying YouTube Embed -->
        <div v-if="isYouTubeUrl(selectedVideoUrl)">
          <iframe
            :src="getYouTubeEmbedUrl(selectedVideoUrl)"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="width: 100%; height: 450px;"
          ></iframe>
        </div>

        <!-- Displaying Video for Direct MP4 Links -->
        <div v-else>
          <video ref="modalVideo" controls autoplay style="width: 100%; height: auto;">
            <source :src="selectedVideoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";

export default {
  data() {
    return {
      videos: [], // Array to hold video data
      config: config,
      selectedLanguage: "", // Track selected language
      selectedProcedure: "", // Track selected procedure
      selectedTestimonial: "", // Track selected testimonial
      selectedJoint: "", // Track selected joint
      selectedExerciseType: "", // Track selected exercise type
      modalVisible: false, // Control modal visibility
      selectedVideoUrl: "", // Store the currently selected video URL
    };
  },

  methods: {

        /* Get Patient  */
        async fetchVideos() {
      const params = new URLSearchParams();
      params.append("custom_language", this.selectedLanguage);
      params.append("custom_type_of_procedure", this.selectedProcedure); // Replace with the actual patient name
      params.append("custom_testimonial", this.selectedTestimonial); // Replace with the actual city
      params.append("custom_joint", this.selectedJoint); 
      params.append("custom_type_of_excercise", this.selectedExerciseType);

      await CommonApi.get_data("sahaj.api.get_videos", params).then((response) => {
        if (response && response.data) {
          this.videos = response.data.map((video, index) => ({
            id: index + 1,
            title: video.title,
            url: video.url,
            provider: video.provider,
            description: video.description,
            thumbnail: `https://img.youtube.com/vi/${this.getYouTubeVideoId(video.url)}/0.jpg`, // Using YouTube API for thumbnail
          }));
        } else {
          console.error("Failed to load videos: Invalid response format", response);
        }
      });

    },


    // Open modal and set the selected video URL
    openModal(videoUrl) {
      this.selectedVideoUrl = videoUrl;
      this.modalVisible = true;
    },

    // Close the modal
    closeModal() {
      this.modalVisible = false;
      this.selectedVideoUrl = "";
    },

    // Helper: Check if the URL is a YouTube URL
    isYouTubeUrl(url) {
      return url.includes("youtube.com") || url.includes("youtu.be");
    },

    // Helper: Convert YouTube URL to Embed URL
    getYouTubeEmbedUrl(url) {
      const videoId = this.getYouTubeVideoId(url);
      return `https://www.youtube.com/embed/${videoId}`;
    },

    // Extract YouTube Video ID
    getYouTubeVideoId(url) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : null;
    },
  },

  mounted() {
    this.fetchVideos();
  },
};
</script>

<style scoped>
/* Video Card Grid */
/* Video Card Grid */
.video-library {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.video-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.video-info {
  padding: 10px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  max-width: 800px;
  width: 90%;
  position: relative;
}

.close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}

/* Responsive media queries */
@media (max-width: 768px) {
  .content {
    padding: 10px;
  }
  .video-library {
    grid-template-columns: repeat(2, 1fr);
  }
  .search-input,
  .search-dropdown {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .video-library {
    grid-template-columns: 1fr;
  }
  .search-input,
  .search-dropdown {
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/videolibrary.vue